import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ClaimWithCase } from 'src/app/core/services/claims.service';

@Component({
  selector: 'app-all-done-dialog',
  templateUrl: './all-done-dialog.component.html',
  styleUrls: ['./all-done-dialog.component.scss'],
})
export class AllDoneDialogComponent {
  claim: ClaimWithCase;

  constructor(@Inject(MAT_DIALOG_DATA) public data: { claim: ClaimWithCase }) {
    this.claim = data.claim;
  }
}
